import GoalsType from './GoalsType';
import GoalsSubtype from './GoalsSubtype';
import SmartGoals from './SmartGoals';
import SmartGoalTemplate from './SmartGoalTemplate';
import GoalsCreate from './GoalsCreate';

export const goalStepMeta = {
  goals: [
    {
      id: 'type',
      category: 'goals',
      component: GoalsType,
    },
    {
      id: 'subtype',
      category: 'goals',
      component: GoalsSubtype,
    },
    {
      id: 'smart',
      category: 'goals',
      component: SmartGoals,
    },
    {
      id: 'template',
      category: 'goals',
      component: SmartGoalTemplate,
    },
    {
      id: 'create',
      category: 'goals',
      component: GoalsCreate,
    },
  ],
};

export const goalStepKeysMap = {
  goals: {
    step: 'goals',
    stepKeys: ['type', 'subtype', 'smart', 'template', 'create'],
  },
};

export const GOAL_FLOW = {
  ENTRY: 'type',
  STEPS: ['type', 'subtype', 'smart', 'template', 'create'],
  EXIT: '/tabs/goals',
};

export const computeGoalStep = (currentStep) => {
  if (!currentStep) return GOAL_FLOW.ENTRY;

  const currentIndex = GOAL_FLOW.STEPS.indexOf(currentStep);
  if (currentIndex === -1) return GOAL_FLOW.ENTRY;

  const nextStep = GOAL_FLOW.STEPS[currentIndex + 1];
  return nextStep || GOAL_FLOW.EXIT;
};

export const getGoalComponent = (stepId) => {
  const step = goalStepMeta.goals.find((s) => s.id === stepId);
  return step?.component;
};

export const GOALS_ROUTES = {
  TYPE: '/goals-type',
  SUBTYPE: '/goals-subtype',
  SMART: '/goals-create/smart',
  TEMPLATE: '/goals-create/template',
  CREATE: '/goals-create',
  LIST: '/tabs/goals',
};
